import CircularProgress from "@mui/material/CircularProgress";
import serverError from "../../assets/serverError.png";
import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";

const ServerError = () => {
  const [serverStatus, setServerStatus] = useState(null);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    const checkServerStatus = async () => {
      try {
        const response = await fetch(
          "https://memberportal-dev.maxicare.com.ph/"
        );
        setServerStatus(response.status);
      } catch (error) {
        console.error("Error occurred while checking server status:", error);
        setServerStatus(500);
      }
    };

    checkServerStatus();
  }, []);

  const reloadPage = () => {
    setReloading(true);
    window.location.reload();
  };

  if (serverStatus === 200 || serverStatus === null) {
    return null;
  }

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen bg-white">
      <div className="w-full sm:w-148 h-auto rounded-xl">
        <div className="mt-56 sm:mt-8 flex flex-col items-center justify-center text-center p-4">
          <div>
            <img
              src={serverError}
              alt="No Internet Connection"
              height="100px"
              width="100px"
            />
          </div>

          <div className="text-xl font-semibold mt-5">
            Oops! Something's not right
          </div>

          <div className="text-center mt-2">
            We apologize for the inconvenience. Our servers are currently
            experiencing a hiccup, but our team is working tirelessly to fix it.
            Please try again in a few moments. Thank you for your patience and
            understanding
          </div>
        </div>

        <div className="flex flex-col items-center sm:w-full justify-center absolute inset-x-0 bottom-0 sm:relative p-4">
          <Button
            className="w-full bg-[#0947AB] text-white"
            onClick={reloadPage}
            disabled={reloading}
          >
            {reloading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Retry now"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
